require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconStationery.tsx
var IconStationery_exports = {};
__export(IconStationery_exports, {
  default: () => IconStationery_default
});
module.exports = __toCommonJS(IconStationery_exports);

// src/assets/monochrome/stationery.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgStationery = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.0073 1.50238C13.779 1.3295 13.4829 1.27352 13.2073 1.35113L4.48324 3.80754C4.074 3.92277 3.8093 4.29835 3.81655 4.70387V17.769C3.81655 18.2741 4.22602 18.6836 4.73112 18.6836H15.4643C15.9694 18.6836 16.3788 18.2741 16.3788 17.769V4.68973C16.3788 4.18463 15.9694 3.77516 15.4643 3.77516H14.3697V2.23147C14.3697 1.9451 14.2356 1.67527 14.0073 1.50238ZM5.64568 10.4148V5.60429H14.5497V10.4148H5.64568ZM5.64568 16.8544V12.2439H14.5497V16.8544H5.64568Z", fill: "#676F7E" }) });
var stationery_default = SvgStationery;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconStationery.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconStationery = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(stationery_default, {}) });
};
IconStationery.displayName = "IconStationery";
var IconStationery_default = IconStationery;
